import { render } from "./History.vue?vue&type=template&id=e2a9aaa4"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=e2a9aaa4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__